
















































































































import type { Entity } from '@getaccept/lib-shared/src/entity/signing-site/types/entity';
import type { SigningPageUser } from '@getaccept/lib-shared/src/types/signing-page-user';
import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    entity: {
      type: Object as PropType<Entity>,
      required: true,
    },
    sender: {
      type: Object as PropType<SigningPageUser>,
      required: true,
    },
  },
  setup(props) {
    const senderEmail = computed(() => props.entity.email || props.sender.email);

    return {
      senderEmail,
    };
  },
});
